module.exports = " <div class=indicator-box _v-bc147982=\"\"> <div v-if=reduce class=reduce-icon _v-bc147982=\"\"></div> <div v-if=add class=add-icon _v-bc147982=\"\"></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-bc147982!./~/vue-loader/lib/selector.js?type=template&index=0!./src/xman/indicator-cause/indicator-operator/index.vue
// module id = 320
// module chunks = 0